
        require('./index.scss');
        'use strict';

var $ = window.$;
var selector = require('module/city-index/header/header-nav/city-selecter.js');
var $mod = $('.module-loupan-search');
var _module = {
    init: function init() {
        selector($mod);

        var Suggest = require('assets/util/suggest.js');
        var suggestItemLink = $mod.attr('data-inMap') != 1 ? '/loupan/$!{item.proj_id}.html' : 'javascript:void(0)';

        var sugTmpl = '#foreach($item in $sug-list)' + '<li class="suggest-item" node-type="suggest-item" data-gid="$!{item.proj_id}" data-id="$!{item.id}" data-proname="$!{item.proj_name}" data-dist="$!{item.district}"' + 'event-tracking-click event-tracking-param-eventname = "ss" event-tracking-param-suggest = "$!{item.proj_name}" event-tracking-param-city = "$!{item.city_id}">' + '<a class="suggest-link" ' + ($mod.attr('data-inMap') != 1 ? 'target="_blank"' : '') + ' href="' + suggestItemLink + '">' + '<span class="suggest-text">$!{item.proj_name_show}' + '#if($!{item.proj_name} != $!{item.str})<span class="name2">$!{item.str_show}</span>#end</span>' + '<span node-type="suggest-dist" class="suggest-dist"></span></a>' +
        // '#else' +
        // '<a class="suggest-link" target="_blank" href="/loupan/${item.proj_id}.html">${item.str}</a>' +
        // '#end' +
        '</li>' + '#end';

        var suggestBar = new Suggest({
            inputDom: $mod.find('input[node-type="input-search"]'),
            ulDom: $mod.find('ul[node-type="suggest-list"]'),
            tempPid: null,
            renderByData: function renderByData(json) {
                var sugList = [];
                if (json.length > 10) {
                    json.splice(0, 10, json.length - 10);
                }
                var newList = velocityjs.render(sugTmpl, {
                    'sug-list': json
                });
                if (json && json.length > 0) {
                    this.tempIndexInList = -1;
                    $mod.find('ul[node-type="suggest-list"]').html(newList);
                    $mod.find('ul[node-type="suggest-list"]').children().each(function (i, n) {
                        var dist = $(n).attr('data-dist').split(',')[0];
                        $(n).find('span[node-type="suggest-dist"]').text(dist);
                    });
                    $mod.find('ul[node-type="suggest-list"]').show();
                } else {
                    $mod.find('ul[node-type="suggest-list"]').hide();
                }
                $mod.find('li[node-type="suggest-item"]').click(function (e) {
                    $mod.find('input[node-type="input-search"]').val($mod.find(this).attr('data-proname'));
                });
            },
            inputEnter: function inputEnter() {
                if (this.tempPid) {
                    var suggestItemLink = $mod.attr('data-inMap') != 1 ? '/loupan/' + this.tempPid + '.html' : 'javascript:void(0)';
                    window.open(suggestItemLink);
                } else {
                    $mod.find('[node-type="keywordBtn"]').trigger('click');
                }
            },
            tempIndexInList: -1,
            upAndDownKey: function upAndDownKey(dir) {
                if (this.ulDom.children().size() <= 0) {
                    return;
                }
                if (dir == 1) {
                    this.tempIndexInList++;
                    if (this.tempIndexInList >= this.ulDom.children().size()) {
                        this.tempIndexInList = 0;
                    }
                } else {
                    this.tempIndexInList--;
                    if (this.tempIndexInList < 0) {
                        this.tempIndexInList = this.ulDom.children().size() - 1;
                    }
                }
                this.ulDom.children().eq(this.tempIndexInList).addClass('active').siblings().removeClass('active');
                this.inputDom.val(this.ulDom.children().eq(this.tempIndexInList).attr('data-proname'));
                return this.ulDom.children().eq(this.tempIndexInList).attr('data-gid');
            }
        });

        function setUrlQueryOnly(key, value) {
            var qs = window.location.search;
            if (qs.length === 0) {
                return '?' + key + '=' + value; // encodeURIComponent(value);
            }

            var pairs = {};
            var pairStrArr = [];
            qs = qs.substr(1);
            qs = qs.split('&');
            var i;
            for (i = 0, len = qs.length; i < len; i++) {
                var kv = qs[i].split('=');
                pairs[kv[0]] = kv[1];
            }
            pairs[key] = value; // encodeURIComponent(value);

            /* hack begin */
            if (key === 'q' && value === '') {
                delete pairs.q;
            }
            /* hack end */

            for (i in pairs) {
                pairStrArr.push(i + '=' + pairs[i]);
            }

            return pairStrArr.length === 0 ? '' : '?' + pairStrArr.join('&');
        }
        function setUrlQuery(key, value) {
            // var url = window.location.href;
            var url = $mod.find('[node-type="keywordBtn"]').data('url');
            return url + setUrlQueryOnly(key, value);
        }

        suggestBar.init();

        var $keywordBtn = $mod.find('[node-type~="keywordBtn"]');
        if ($mod.attr('data-inSearch') == 1) {
            $keywordBtn.click(function (e) {
                e.preventDefault();

                var inputDom = $mod.find('input[node-type~="input-search"]');
                var q = inputDom.val();
                var placeHolder = inputDom.data('value');
                $keywordBtn.attr('event-tracking-param-keywords', q);

                if (q !== placeHolder) {
                    window.location.href = setUrlQuery('q', q);
                } else {
                    window.location.reload();
                }
            });
        } else if ($mod.attr('data-inMap') != 1) {
            $keywordBtn.click(function (e) {
                e.preventDefault();
                var inputDom = $mod.find('input[node-type~="input-search"]');
                var q = inputDom.val();
                var placeHolder = inputDom.data('value');
                $keywordBtn.attr('event-tracking-param-keywords', q);

                if (!q || q === '' || q === placeHolder) {
                    window.open('//' + window.location.host + '/loupan/');
                } else {
                    // window.open('//' + window.location.host + '/loupan/?q=' + encodeURIComponent(q));
                    window.open('//' + window.location.host + '/loupan/?q=' + q);
                }
            });
        } else {
            $keywordBtn.click(function (e) {
                e.preventDefault();
                var $isbtn = $mod.find('input[node-type~="input-search"]');
                var q = $isbtn.val();
                $keywordBtn.attr('event-tracking-param-keywords', q);

                if (q === $isbtn.attr('data-value')) {
                    q = '';
                }
                // map相关逻辑 暂时用不着
                // mdev.message.trigger('map-search', 'query-search', q);
            });

            // mdev.message.listen(function (cmd, data) {
            //     switch (cmd) {
            //     case 'query-clear':
            //         var $isbtn = $mod.find('input[node-type~="input-search"]');
            //         $isbtn.val($isbtn.attr('data-value') || '');
            //     }
            // });
        }

        $mod.find('[node-type="input-search"]').focus(function () {
            var curInput = $(this);
            var curInputPalceholder = curInput.data('value');
            if (curInput.val() === curInputPalceholder) {
                curInput.val('');
                $(this).css('color', '#303033');
            }
        }).blur(function (e) {
            var curInput = $(this);
            var curInputPalceholder = curInput.data('value');
            if (curInput.val() === '') {
                curInput.val(curInputPalceholder);
                $(this).css('color', '#9f9fa6');
            }
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/loupan-common/search-new/index.js